import script from "./PanelInvitations.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelInvitations.vue?vue&type=script&setup=true&lang=js"

import "./PanelInvitations.vue?vue&type=style&index=0&id=850d1df6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-850d1df6"]])

export default __exports__